import React from "react";
import Seo from "../components/Seo";
import Layout from "../layouts/sample";
import {Intro} from '../components/brand/Intro';
import {Figma} from '../components/brand/Figma';
import {Join} from '../components/brand/Join';
import {graphql} from "gatsby";

const BrandPage = (props) => {
  const acf = props.data.page.template?.brandPageACF || {};

  const translations = props?.data?.page?.translations || {}

  return (
    <Layout translations={translations}>
      <Intro data={acf.intro ||{}} />
      <Figma data={acf.figma ||{}} />
      <Join data={acf.join ||{}} />
    </Layout>
  );
};

export default BrandPage;
export const pageQuery = graphql`
query ($lng: String!, $id: Int!) {
  locales: allLocale(
    filter: { language: { eq: $lng } }
  ) {
    edges {
      node {
        ns
        data
        language
      }
    }
  }
  page : wpPage(language: {slug: {eq: $lng}}, databaseId: { eq: $id }) {
    seo {
      metaDesc
      opengraphDescription
      opengraphTitle
      title
    }
    translations {
      slug
    }
    template {
      ... on WpTemplate_Brand {
        brandPageACF {
          figma {
            url
          }
          intro {
            number
            suptext1
            suptext3
            text
            text2
            titlePart1
            titlePart2
            titlePart3
            link {
              title
              url
              target
            }
            fileBtnText
            file {
              publicUrl
              localFile {
                publicURL
              }
            }
          }
          join {
            title
            text
            subtitle
            number
            link {
              target
              title
              url
            }
          }
        }
      }
    }
  }
}
`;
export const Head = (props) => {
  const seo = props.data.page?.seo || {}
  return <Seo title={seo?.title} description={seo?.metaDesc} />;
}
